import { useCallback, useState } from 'react';

import { snapdocsClosingApi } from 'app/services/api';

import { getDefaultErrorMessage } from 'utils/axios';

import { sortAuditEventsNewestFirst } from '../../../SnapdocsClosingSection.utils';
import { AuditTrailLoadState } from '../SnapdocsAuditTrailBlock.constants';

export const useSnapdocsAuditTrail = ({ applicationId, companyId }) => {
  const [loadState, setLoadState] = useState(AuditTrailLoadState.IDLE);
  const [events, setEvents] = useState([]);
  const [errorMessage, setErrorMessage] = useState(null);

  const load = useCallback(async () => {
    setLoadState(AuditTrailLoadState.LOADING);
    setErrorMessage(null);

    try {
      const { data } = await snapdocsClosingApi.getAudit({ applicationId, companyId });

      setEvents(sortAuditEventsNewestFirst(data));
      setLoadState(AuditTrailLoadState.LOADED);
    } catch (error) {
      setErrorMessage(getDefaultErrorMessage(error));
      setLoadState(AuditTrailLoadState.ERROR);
    }
  }, [applicationId, companyId]);

  return { loadState, events, errorMessage, load };
};
